import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VacancyType } from '../../../types/Vacancy';

const initialState:VacancyType = {
  id: '',
  idAcademicYear: '',
  numberOfVacancies: 0,
  status: false,
  idCourse: '',
  idDepartament: '',
  idFaculty: ''
}

const vacancySlice = createSlice({
  name: "vacancyForm",
  initialState,
  reducers: {
    setVacancyData:(state, action:PayloadAction<VacancyType>)=>({...state, ...action.payload}), 
    resetVacancyData :()=>({...initialState})
  }
});

export const {setVacancyData, resetVacancyData} = vacancySlice.actions

export default vacancySlice.reducer